import { makeStyles } from '@material-ui/core/styles';

import { getCircleSize, SCORE_SIZE } from 'src/components/Score';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      gap: theme.spacing(0.5),

      '&$vertical': {
        flexFlow: 'column nowrap',
        height: getCircleSize(SCORE_SIZE.large),
      },

      '&$small': {
        '& $buttonGetScore': {
          minWidth: 40,
          fontSize: theme.typography.pxToRem(9),
        },
        '& $lanternIcon': {
          fontSize: theme.typography.pxToRem(24),
          borderWidth: 1,
        },
      },
    },
    vertical: {},
    small: {},

    buttonGetScore: {
      color: COLORS.success.active,
      fontWeight: theme.typography.fontWeightSemiBold,
      padding: 0,
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      '&:hover': {
        background: 'unset',
      },
    },

    buttonUndo: {
      minWidth: 'auto',
      marginLeft: theme.spacing(0),
      padding: 0,
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      color: COLORS.neutral.mediumGray,
      textDecoration: 'none',

      '&:focus:enabled': {
        color: COLORS.neutral.mediumGray,
      },
      '&:hover:enabled': {
        color: COLORS.primary.default,
      },
      '&[disabled]': {
        color: theme.palette.action.disabled,
      },
      '$vertical &': {
        marginLeft: 0,
      },
    },

    lanternIcon: {
      border: `2px solid ${COLORS.gray.gray60}`,
      borderRadius: '50%',
      fontSize: theme.typography.pxToRem(35),
      padding: 5,
    },
  }),
  { name: 'LockedScoreButtons' }
);
